import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import styles from "./style.module.scss";
import ProviderInvoiceMessageForm from "@components/forms/ProviderInvoiceMessageForm";

const ValidateEInvoice = () => {

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title="Validar Factura de Provedor"
      backUrl="/user/provider-invoices"
    >
      <ProviderInvoiceMessageForm
        formId="providerValidateForm"
        saveRedirectUrl="/user/provider-invoices"
      ></ProviderInvoiceMessageForm>

    </PageContainer >
  );
}

export default ValidateEInvoice;
